export default {
  setStoresInfo(state, storesInfo) {
    // ====== 全形轉半形 ======
    function formatAddress(str) {
      let tmp = "";
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) == 12288) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
          continue;
        }
        if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        } else {
          tmp += String.fromCharCode(str.charCodeAt(i));
        }
      }
      return tmp;
    }
    const formattedStoresInfo = storesInfo.map(store => {
      store.properties.address = formatAddress(store.properties.address);
      return store;
    });
    state.storesInfo = formattedStoresInfo;
  },
  setUserCoords(state, userCoords) {
    state.userCoords = userCoords;
  },
  resetMapCenter(state, searchedCoords) {
    state.userCoords = searchedCoords;
  },
  setSearchKeywords(state, searchedKeywords) {
    state.searchedKeywords = searchedKeywords;
  }
};
